import {Checkbox, Col, Form, Input, Row, Select} from "antd";
import React, {Fragment} from 'react';
import {compose} from "redux";
import _ from "lodash";
import {translate} from "react-i18next";
import {GUTTER_MD} from "../../../../styles/constants";
import InputListForm from "../../../../components/input-list-form";
import {PROVIDERS} from "./LoginProvidersForm";

const mapPropsToFields = ({value: LoginProvider}) => ({
  AppId: Form.createFormField({value: (LoginProvider && LoginProvider.AppId) ? LoginProvider.AppId : null}),
  AppSecret: Form.createFormField({value: (LoginProvider && LoginProvider.AppSecret) ? LoginProvider.AppSecret : null}),
  AuthorizationURL: Form.createFormField({value: (LoginProvider && LoginProvider.AuthorizationURL) ? LoginProvider.AuthorizationURL : null}),
  Enabled: Form.createFormField({value: LoginProvider ? LoginProvider.Enabled : true}),
  GrantType: Form.createFormField({value: (LoginProvider && LoginProvider.GrantType) ? LoginProvider.GrantType : null}),
  Label: Form.createFormField({value: (LoginProvider && LoginProvider.Label) ? LoginProvider.Label : null}),
  LoginBaseURL: Form.createFormField({value: (LoginProvider && LoginProvider.LoginBaseURL) ? LoginProvider.LoginBaseURL : null}),
  ProviderName: Form.createFormField({value: (LoginProvider && LoginProvider.ProviderName) ? LoginProvider.ProviderName : null}),
  UserPassword: Form.createFormField({value: (LoginProvider && LoginProvider.UserPassword) ? LoginProvider.UserPassword : null}),
  SuperadminMails: Form.createFormField({value: (LoginProvider && LoginProvider.SuperadminMails) ? LoginProvider.SuperadminMails : []}),
});

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const LoginProviderForm = ({
                             t,
                             form,
                             value: LoginProvider,
                             availableProviders
                           }) => {
  return (
    <Fragment>
      <Form.Item
        className="form-item-required"
        label={t('data.nodesConfig.loginProvider.providerName.label')}
      >
        {form.getFieldDecorator('ProviderName')(
          <Select
            style={{width: "100%"}}
            disabled={LoginProvider.IsNewProvider !== true}
          >
            {PROVIDERS.map((provider, idx) => (
              <Select.Option
                key={idx}
                value={provider}
                disabled={![...availableProviders, form.getFieldValue("ProviderName")].includes(provider)}
              >
                {provider}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
      <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD} style={{marginBottom: 0}}>
        <Col style={{color: 'rgba(0, 0, 0, 0.85)'}}>
          {t("data.nodesConfig.loginProvider.enabled.label") + ' :'}
        </Col>
        <Col>
          <Form.Item>
            {form.getFieldDecorator("Enabled", {valuePropName: 'checked'})(
              <Checkbox/>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        label={t('data.nodesConfig.loginProvider.label.label')}
      >
        {form.getFieldDecorator('Label')(<Input/>)}
      </Form.Item>
      <Form.Item
        className="form-item-required"
        label={t('data.nodesConfig.loginProvider.loginBaseUrl.label')}
      >
        {form.getFieldDecorator('LoginBaseURL')(<Input/>)}
      </Form.Item>
      <Form.Item
        className="form-item-required"
        label={t('data.nodesConfig.loginProvider.authorizationUrl.label')}
      >
        {form.getFieldDecorator('AuthorizationURL')(<Input/>)}
      </Form.Item>
      <Form.Item
        className="form-item-required"
        label={t('data.nodesConfig.loginProvider.appId.label')}
      >
        {form.getFieldDecorator('AppId')(<Input/>)}
      </Form.Item>
      {LoginProvider.IsNewProvider === true && (
        <Fragment>
          <Form.Item
            label={t('data.nodesConfig.loginProvider.grantType.label')}
          >
            {form.getFieldDecorator('GrantType')(<Input/>)}
          </Form.Item>
          <Form.Item
            label={t('data.nodesConfig.loginProvider.appSecret.label')}
          >
            {form.getFieldDecorator('AppSecret')(<Input/>)}
          </Form.Item>
          <Form.Item
            label={t('data.nodesConfig.loginProvider.userPassword.label')}
          >
            {form.getFieldDecorator('UserPassword')(<Input type={"password"}/>)}
          </Form.Item>
        </Fragment>
      )}
      <Form.Item
        label={t('data.nodesConfig.loginProvider.superadminMails.label')}
      >
        {form.getFieldDecorator('SuperadminMails', {valuePropName: 'values'})(
          <InputListForm
            addItemLabel={t('scenes.configuration.nodesConfig.loginProvider.superadminMails.addButton.title')}
            removeItemLabel={t('scenes.configuration.nodesConfig.loginProvider.superadminMails.removeButton.title')}
          />
        )}
      </Form.Item>
    </Fragment>
  )
};

export default compose(
  translate(),
  Form.create({mapPropsToFields, onFieldsChange})
)(LoginProviderForm);



// WEBPACK FOOTER //
// ./src/scenes/configuration/nodes-config/node/LoginProviderForm.jsx